(function($) {
	$(document).ready(function(){
		if ($.fn.slick) {
			$('.testimonial-slider > .wp-block-group__inner-container').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				dots: true,
				prevArrow: '<button class="slick-prev"><img src="/wp-content/uploads/chevron-left-white.png" alt=""></button>',
				nextArrow: '<button class="slick-next"><img src="/wp-content/uploads/chevron-right-white.png" alt=""></button>',
				appendArrows: '.testimonial-slider',
				responsive: [
					{
						breakpoint: 992,
						settings: {
							dots: false
						}
					},
				]
			});
		} 
	});
})(jQuery);
